// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"UnauthPage_formWrapper__3Mco6","logoWrapper":"UnauthPage_logoWrapper__3ok14","error":"UnauthPage_error__3DVmI"};